import { TokenExtension } from '@utils/extensions/token.extension.ts';
import { Roles } from '@utils/types/shared/base.ts';
import { useOrganization } from '@utils/api/users/use-get-organization.tsx';

export function useRoles() {
  const userRoles = TokenExtension.get()?.decoded?.scopes;
  const { data: organization } = useOrganization(); // Fetch organization data

  const isReseller = userRoles?.includes(Roles.RESELLER);
  const isAdmin = userRoles?.includes(Roles.ORGADMIN);
  const isSysOp = userRoles?.includes(Roles.SYSOP);
  const isCustomer = userRoles?.includes(Roles.CUSTOMER);
  const isTester = userRoles?.includes(Roles.TESTER);
  const isDeveloper = userRoles?.includes(Roles.DEVELOPER);
  const isContributor = userRoles?.includes(Roles.CONTRIBUTOR);
  const isResellee =
    userRoles?.includes(Roles.RESELLEE) && organization?.is_resellee;

  return {
    roles: userRoles,
    isReseller,
    isAdmin,
    isSysOp,
    isCustomer,
    isTester,
    isDeveloper,
    isContributor,
    isResellee
  };
}
